declare namespace $ {

	type $mol_text__text_bog_pazzle_saves_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_major__hint_bog_pazzle_saves_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['hint'] >
	>
	type $mol_button_major__click_bog_pazzle_saves_3 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves['create'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_button_major__sub_bog_pazzle_saves_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $bog_pazzle_saves_item__id_bog_pazzle_saves_5 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves['row_id'] >
		,
		ReturnType< $bog_pazzle_saves_item['id'] >
	>
	type $bog_pazzle_saves_item__open_bog_pazzle_saves_6 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves['open'] >
		,
		ReturnType< $bog_pazzle_saves_item['open'] >
	>
	type $bog_pazzle_saves_item__drop_bog_pazzle_saves_7 = $mol_type_enforce<
		ReturnType< $bog_pazzle_saves['drop'] >
		,
		ReturnType< $bog_pazzle_saves_item['drop'] >
	>
	export class $bog_pazzle_saves extends $mol_list {
		row_id( id: any): string
		drop( next?: any ): any
		Empty( ): $mol_text
		Create_icon( ): $mol_icon_image_plus
		Create( ): $mol_button_major
		saves_content( ): readonly(any)[]
		open( next?: any ): any
		create( next?: any ): any
		Row( id: any): $bog_pazzle_saves_item
		rows( ): ReturnType< $bog_pazzle_saves['saves_content'] >
	}
	
}

//# sourceMappingURL=saves.view.tree.d.ts.map